// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '한국휴텍스제약',
  targetSheetName: '휴텍스제약',
  headerRowIndex: 3,
  headerRowCount: 1,
  dataStartRowIndex: 4,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제 품 명',
    price: '약가',
    commissionRate: '정책',
    commissionNote: '비 고',
  },
  requiredHeaders: [
    '순번',
    '보험코드',
    '제 품 명',
    '분 류',
    '성 분 명',
    '성 분 명',
    '정책',
    '약가',
    '비 고',
  ],
});
